// extracted by mini-css-extract-plugin
export default {"imgBox":"UploadImg_imgBox__AV591"};